var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cs-overlay",class:{ 'is-visible': _vm.visible },on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.spinner)?_c('cs-spinner',{staticClass:"is-white"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }